<template>
  <!-- 商品占用库存查询 -->
  <div class="limitManCx">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="getTableData('refresh')"
      :crumbsList="['商品管理', $route.meta.title]"
    >
      <template slot="controls">
        <!-- <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd()"
          >新增</el-button
        >
        <el-button type="danger" @click="handleDel()">删除</el-button> -->
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input
          v-model="searchForm.name"
          style="width: 180px; margin-right: 5px"
          clearable
          placeholder="名称"
        >
        </el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="getTableData('search')"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      :row-style="{ color: '#303133' }"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
      row-key="id"
    >
      <!-- <el-table-column type="selection" align="center" width="55">
      </el-table-column> -->
      <el-table-column label="序号" align="center" type="index">
      </el-table-column>
      <el-table-column
        prop="LimitId"
        align="center"
        show-overflow-tooltip
        label="方案编号"
      >
      </el-table-column>
      <el-table-column
        prop="StartTime"
        align="center"
        show-overflow-tooltip
        label="开始时间"
      >
      </el-table-column>
      <el-table-column
        prop="EndTime"
        align="center"
        show-overflow-tooltip
        label="结束时间"
      >
      </el-table-column>
      <el-table-column
        prop="GoodsName"
        align="center"
        show-overflow-tooltip
        label="商品名称"
      >
      </el-table-column>
      <el-table-column
        prop="DrugSpec"
        align="center"
        show-overflow-tooltip
        label="规格"
      >
      </el-table-column>
      <el-table-column
        prop="Quantity"
        align="center"
        show-overflow-tooltip
        label="限购数量"
      >
      </el-table-column>
      <!-- <el-table-column
        prop="LimitType"
        align="center"
        show-overflow-tooltip
        label="客户类型"
      >
      </el-table-column> -->
      <el-table-column
        prop="DrugFactory"
        align="center"
        show-overflow-tooltip
        label="生产厂家"
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "limitManCx",
  data() {
    return {
      /**搜索内容 */
      searchForm: {
        name: "",
        status: "99", //99 全部 1禁用 2 启用
      },

      /**表格数据 */
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,

      /**select选中项 */
      selectedList: [],

      /*************** 新增规则相关 ***************/
      addDrawer: false /**新增drawer */,
      /**表单数据 */
      //区域 下单金额门槛 折扣门槛 免邮门槛 邮费
      addForm: {
        id: "",
        title: "", //方案名称
        status: 1, //作为判断使用
        goodsList: [], //商品
        limitType: "LT1", //限制类型 LT1 间隔时间 LT2 间隔天数
        limitDay: 0, //间隔天数
        startTime: "", //间隔时间值
        endTime: "", //间隔时间值
        userType: [], //选中的客户类型
        areaValue: [], // 选中的区域编码
        selectAreaNodes: [], // 选中区域的节点信息，包含label
      },
      submitType: "add", //提交类型，编辑还是新增
      /**表单验证 */
      formRule: {
        title: [mustFill],
        startTime: [mustFill],
        endTime: [mustFill],
        // endTime: [this.limitMustFill()],
        limitDay: [mustFill],
        limitType: [mustFill],
        userType: [mustFill],
        // areaValue: [mustFill],
      },

      /**客户类型列表 */
      userTypeList: [],

      /********* 商品列表选项数据 **********/
      goodsName: "", //检索使用，商品名称
      goodsDialog: false, //dialog
      goodsList: [], //查询到的商品列表
      tableHeader: {}, //表头数据，要改成动态表格的形式
      /**商品列表分页数据 */
      currPage2: 1,
      pageSize2: 20,
      allPage2: 0,
      goodsDialog2: false, //绑定商品的dialog，后来加的

      /**区域控销选项数据 */
      areaDialog: false, //dialog状态
      areaList: [],
    };
  },
  mounted() {
    this.getTableData("refresh");
    this.getAreaList();
    this.getUserType();
  },
  methods: {
    // 类型判断时间是否必填
    limitMustFill() {
      return {
        validator: (rule, value, callback) => {
          if (this.addForm.limitType == "LT1") {
            if (!value) {
              return callback(new Error("该字段为必填项"));
            } else {
              return callback();
            }
          } else {
            return callback();
          }
        },
      };
    },
    /**获取表格 */
    getTableData(type = "load") {
      if (type == "search") {
        this.currPage = 1;
      } else if (type == "refresh") {
        this.currPage = 1;
        this.searchForm.name = "";
      }

      let data = {
        valStr: this.searchForm.name,
        status: this.searchForm.status,
        pageIndex: this.currPage,
        pageSize: this.pageSize,
      };

      this.$request({
        url: "Management/GoodsAdmin/GetGoodsLimitDetailList", //?type=" + type + "&proc=" + proc,
        method: "post",
        data: data,
      })
        .then((res) => {
          this.tableData = [];
          if (res.success) {
            this.tableData = res.dataList || [];
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**删除 */
    handleDel() {
      let row = {};
      if (this.selectedList.length == 1) {
        // this.$confirm("确定删除吗?", "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "error",
        // })
        //   .then(() => {
        console.log("1111");
        row = this.selectedList[0];
        this.handleStatus(row, 0);
        //     })
        //     .catch(() => {});
        // } else {
        //   this.$message({
        //     message: "只能删除一条数据",
        //     type: "warning",
        //   });
      }
    },
    /**更改状态 */
    handleStatus(row, status) {
      //0 删除 1 禁用 2 启用
      let tips = "确定要启用吗？";
      let type = "success";
      if (status == 2) {
        tips = "确定要启用吗？";
        type = "success";
      } else if (status == 1) {
        tips = "确定要禁用吗？";
        type = "warning";
      } else if (status == 0) {
        tips = "确定要删除吗？";
        type = "error";
      }
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          console.log(row, "2323");
          let data = {
            ids: row.LimitId,
            status: status,
          };
          this.$request({
            url: "/Management/GoodsAdmin/AuditGoodsLimitSales",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getTableData("refresh");
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },

    /**编辑操作 */
    handleEdit({ row }) {
      let data = {
        ids: row.LimitId,
      };
      this.$request({
        url: "/Management/GoodsAdmin/GetGoodsLimitSalesDetail",
        method: "post",
        data: data,
      }).then((res) => {
        if (res.success) {
          let dataModel = res.dataModel;
          this.addForm.id = dataModel.LimitId;
          this.addForm.title = dataModel.Title;
          this.addForm.status = dataModel.Status;
          this.addForm.limitType = dataModel.LimitType;
          this.addForm.startTime = dataModel.StartTime;
          this.addForm.endTime = dataModel.EndTime;
          this.addForm.limitDay = dataModel.LimitDay;
          dataModel.controlList.forEach((item) => {
            if (item.ControlType == "Client") {
              this.addForm.userType.push(item.LimitCode);
            } else if (item.ControlType == "Area") {
              this.addForm.areaValue.push(item.LimitCode);
            }
          });

          this.addForm.goodsList = dataModel.goodsList; //因为字段名都一样
          this.addDrawer = true;
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },

    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },

    /*************** 新增规则相关 ******************/
    /**点击新增 */
    handleAdd() {
      this.addForm = {
        id: "",
        title: "", //方案名称
        goodsList: [], //商品
        limitType: "LT1", //限制类型 LT1 间隔时间 LT2 间隔天数
        limitDay: 0, //间隔天数
        startTime: "", //间隔时间值
        endTime: "", //间隔时间值
        userType: [], //选中的客户类型
        areaValue: [], // 选中的区域编码
        selectAreaNodes: [], // 选中区域的节点信息，包含label
        status: 1,
      };
      this.$nextTick(() => {
        this.$refs.addForm.resetFields();
      });
      this.addDrawer = true;
    },

    /************ 获取区域列表 ****************/
    getAreaList() {
      this.$request({
        method: "post",
        url: "/Base/GetTreeAreaListApi",
      })
        .then((res) => {
          if (res.success) {
            this.areaList = res.dataList || [];
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**cascader change回调 */
    onCascaderChange() {
      this.addForm.selectAreaNodes =
        this.$refs["areaCascader"].getCheckedNodes(); //获取选中的节点信息，主要是获取value和label
    },

    /************ 获取商品列表 ****************/
    /**点击打开数据选择框 */
    handleChoose() {
      // 获取数据
      this.goodsDialog = true;
      this.getGoodsList("refresh");
    },

    /**清空选中商品 */
    handleClearGoods() {
      this.$confirm("确定清空吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 清空选中商品数据
          this.addForm.goodsList = [];
        })
        .catch(() => {});
    },

    /**获取数据 */
    getGoodsList(load = "") {
      // 需要根据选择的商品范围来判断获取不同的数据
      if (load == "refresh") {
        this.currPage2 = 1;
        this.goodsName = "";
      } else if (load == "search") {
        this.currPage2 = 1;
      }

      let data = {
        type: "GoodsList",
        PageIndex: this.currPage2,
        PageSize: this.pageSize2,
        strWhere: this.goodsName,
      };

      let proc = "Proc_Admin_SearchInfo"; //存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          type +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.goodsList = res.content;
            this.tableHeader = res.fdname;
            this.allPage2 = res.recordCount;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**分页size改变 */
    hanSiChange2(val) {
      this.pageSize2 = val;
      this.getGoodsList();
    },

    /**当前页改变 */
    hanCurrChange2(val) {
      this.currPage2 = val;
      this.getGoodsList();
    },

    /**选中某一个条数据 */
    handleGoodsItem({ row }) {
      this.addForm.goodsList.push({
        LimitId: this.addForm.id,
        ArtileId: row.keyid,
        goodscode: row.goodscode,
        Quantity: 1,
        DrugSpec: row.drug_spec,
        DrugFactory: row.drug_factory,
        GoodsName: row.sub_title,
      });
    },

    /**删除选中的某一个商品 */
    handleDelGoods({ row }) {
      this.addForm.goodsList = this.addForm.goodsList.filter(
        (item) => item.ArtileId != row.keyid
      );
    },

    /**表格数据选中状态判断 */
    tableRowClassName({ row }) {
      for (let i = 0; i < this.addForm.goodsList.length; i++) {
        let item = this.addForm.goodsList[i];
        if (item.ArtileId == row.keyid) {
          return "success-row";
        }
      }

      return "";
    },

    /********** 客户类型获取相关 ***********/
    getUserType() {
      let data = {
        type: "CustomType",
      };
      let proc = "Proc_Admin_CustomerList"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "coupon/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.userTypeList = res.data.map((item) => {
              return {
                label: item.clienttype,
                value: item.TypeID,
              };
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**提交 */
    submitForm() {
      console.log("1212121");
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          this.$confirm("确定提交吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              /**控销数据 */
              let ActivityControl = [];
              this.addForm.areaValue.forEach((item) => {
                ActivityControl.push({
                  LimitId: this.addForm.id,
                  ControlType: "Area", //Area/Client
                  LimitCode: item,
                  LimitName: item, //前端通过id就可显示出名称，这里就不传了
                });
              });
              //客户类型控销
              this.addForm.userType.forEach((item) => {
                ActivityControl.push({
                  LimitId: this.addForm.id,
                  ControlType: "Client", //Area/Client
                  LimitCode: item,
                  LimitName: item, //前端通过id就可显示出名称，这里就不传了
                });
              });
              if (this.addForm.limitType == "LT1") {
                if (
                  this.addForm.startTime == "" &&
                  this.addForm.endTime == ""
                ) {
                  this.$message({
                    message: "选择间隔天数时间时开始时间和结束时间不能为空",
                    type: "error",
                  });
                  return;
                }
              }
              let data = {
                LimitId: this.addForm.id,
                Title: this.addForm.title, //方案编号
                LimitType: this.addForm.limitType, //限制类型 LT1 间隔时间 LT2 间隔天数
                StartTime: this.addForm.startTime,
                EndTime: this.addForm.endTime,
                LimitDay: this.addForm.limitDay,
                goodsList: this.addForm.goodsList,
                controlList: ActivityControl,
              };
              console.log(data);
              console.log(JSON.stringify(data));

              this.$request({
                method: "post",
                url: "/Management/GoodsAdmin/EditGoodsLimitSales",
                data: data,
              })
                .then((res) => {
                  let type = "success";
                  if (res.success) {
                    type = "success";
                    this.clearForm();
                    this.getTableData("refresh");
                  } else {
                    type = "error";
                  }

                  this.$message({
                    message: res.message,
                    type,
                  });
                })
                .catch((err) => {
                  window.console.log(err);
                });
            })
            .catch((e) => {
              console.log(e);
            });
        }
      });
    },

    /**关闭drawer 清空表单信息 */
    clearForm() {
      this.addForm = {
        id: "",
        title: "", //方案名称
        goodsList: [], //商品
        limitType: "LT1", //限制类型 LT1 间隔时间 LT2 间隔天数
        limitDay: 0, //间隔天数
        startTime: "", //间隔时间值
        endTime: "", //间隔时间值
        userType: [], //选中的客户类型
        areaValue: [], // 选中的区域编码
        selectAreaNodes: [], // 选中区域的节点信息，包含label
      };
      // this.$refs.addForm.resetField();
      this.addDrawer = false;
    },
  },
};
</script>

<style scoped>
.limitManCx {
  width: 100%;
  height: 100%;
}

/**新增表单抽屉 */
.drawer-con {
  height: calc(100% - 90px);
}

/**表单输入框 */
.form-input {
  width: 200px;
}

.form-item-goods {
  display: flex;
  align-items: center;
}
</style>
